function Shiping(props) {
    return (
        <div className="shipping text-center">
            <img src="images/home/shipping.jpg" alt="" />
        </div>
    );
}

export default Shiping;